import * as types from './types';
import * as constants from './constants';

export const addLogEntry = (entry: types.LogEntry): types.AddLogEntryAction => {
    return {
        type: constants.ADD_LOG_ENTRY,
        entry
    }
}

export const clear = (): types.ClearAction => {
    return {
        type: constants.CLEAR
    }
}
